import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { NeonButton } from './NeonButton';
import { XCircle, CheckCircle, ArrowRight } from 'lucide-react';
export function ClosingSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <SectionWrapper className="pb-32" data-id="element-15">
      <div className="text-center mb-12" data-id="element-16">
        <h2 className="text-3xl md:text-5xl text-white font-mono mb-4" data-id="element-17">
          Tienes{' '}
          <span className="text-cyber-neon text-shadow-neon" data-id="element-18">dos caminos</span>{' '}
          frente a ti:
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-19">
        {/* Camino A - Negative */}
        <div className="bg-cyber-black border border-cyber-red/30 rounded-xl p-8 relative overflow-hidden opacity-80 hover:opacity-100 transition-opacity" data-id="element-20">
          <div className="absolute top-0 left-0 w-full h-1 bg-cyber-red/50" data-id="element-21"></div>
          <div className="flex items-center gap-3 mb-6" data-id="element-22">
            <XCircle className="w-8 h-8 text-cyber-red" data-id="element-23" />
            <h3 className="text-2xl font-mono font-bold text-gray-400" data-id="element-24">
              Camino A
            </h3>
          </div>
          <p className="text-gray-500" data-id="element-25">
            Cierras esta página y sigues siendo el que se esconde en el baño, el
            que pierde oportunidades y el que se siente solo en medio de la
            multitud.
          </p>
        </div>

        {/* Camino B - Positive */}
        <div className="bg-cyber-dark border border-cyber-neon rounded-xl p-8 relative overflow-hidden shadow-[0_0_30px_rgba(57,255,20,0.1)]" data-id="element-26">
          <div className="absolute top-0 left-0 w-full h-1 bg-cyber-neon shadow-neon" data-id="element-27"></div>
          <div className="flex items-center gap-3 mb-6" data-id="element-28">
            <CheckCircle className="w-8 h-8 text-cyber-neon" data-id="element-29" />
            <h3 className="text-2xl font-mono font-bold text-white" data-id="element-30">
              Camino B
            </h3>
          </div>
          <p className="text-gray-300" data-id="element-31">
            Inviertes <strong className="text-cyber-neon" data-id="element-32">$6.36 hoy</strong> (el
            precio de una pizza) y empiezas a hackear tu realidad social para
            convertirte en la persona que siempre quisiste ser.
          </p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto text-center" data-id="element-33">
        <NeonButton size="lg" fullWidth href="https://www.tumomentovital.com/cart/47625937879232:1" className="text-lg md:text-2xl py-6 md:py-8 shadow-neon-strong animate-pulse-fast" data-id="element-34">
          SÍ, QUIERO HACKEAR MI ANSIEDAD — ACCESO POR SOLO $6.36{' '}
          <ArrowRight className="ml-2 w-6 h-6 md:w-8 md:h-8" data-id="element-35" />
        </NeonButton>
      </div>
    </SectionWrapper>;
}